import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { message, Modal } from 'antd';
import { ButtonWrapper } from 'components/ButtonWrapper';
import { addUser } from 'store/pageSlice';

export default function DeleteTeamMemberModal({ open, onCancel, member, buId, onDelete }) {
	const dispatch = useDispatch();
	if (!member) return null;

	const handleRemove = async () => {
		if (!buId) {
			message.error('Missing Business Unit ID or User ID. Cannot remove team member.');
			return;
		}
		await dispatch(
			addUser({
				data: {
					update_type: 'remove_bu_user',
					data: {
						bu_id: buId,
						user_id: member.user_id,
					},
				},
				isEditMode: true,
			})
		);
		message.success('Team member removed successfully');
		window.location.reload();
		if (onDelete) onDelete();
		onCancel();
	};

	return (
		<Modal
			open={open}
			onCancel={onCancel}
			footer={null}
			centered
			width={612}
			style={{
				border: '1px solid #000',
				borderRadius: 4,
				padding: 0,
			}}
			bodyStyle={{ padding: 0, background: '#fff', borderRadius: 4 }}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					height: 260,
					position: 'relative',
				}}
			>
				<div
					style={{
						width: 470,
						height: 72,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						position: 'absolute',
						left: 71,
						top: 56.5,
					}}
				>
					<span
						style={{
							fontFamily: 'Inter',
							fontWeight: 600,
							fontSize: 20,
							lineHeight: '180%',
							textAlign: 'center',
							color: '#000',
						}}
					>
						Are you sure you want to remove{' '}
						<span style={{ textDecoration: 'underline' }}>{member.name}</span> (
						{member.role}) from the Team?
					</span>
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'flex-end',
						alignItems: 'flex-end',
						gap: 27,
						position: 'absolute',
						width: 298,
						height: 40,
						left: 157,
						top: 157,
					}}
				>
					<ButtonWrapper
						onClick={onCancel}
						style={{
							border: '1px solid #FF3B30',
							color: '#FF3B30',
							background: '#fff',
							borderRadius: 4,
							height: 40,
							minWidth: 135.5,
							fontSize: 16,
							fontWeight: 500,
						}}
					>
						Cancel
					</ButtonWrapper>
					<ButtonWrapper
						type="primary"
						style={{
							background: '#143E60',
							color: '#fff',
							border: 'none',
							borderRadius: 4,
							height: 40,
							minWidth: 135.5,
							fontSize: 16,
							fontWeight: 500,
						}}
						onClick={handleRemove}
					>
						Remove
					</ButtonWrapper>
				</div>
			</div>
		</Modal>
	);
}

DeleteTeamMemberModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	member: PropTypes.shape({
		name: PropTypes.string,
		role: PropTypes.string,
		user_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	}),
	buId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	onDelete: PropTypes.func,
};
